import React from 'react'
import IndexPage from './IndexPage'
import SubmitEmail from './SubmitEmail'

export interface IRoute {
  id: string
  path: string
  exact: boolean
  component: React.FC
  label: string
  visible?: boolean
}

const ROOT_ROUTE = 'root'
const EMAIL_ROUTE = 'email'

const routes: IRoute[] = [
  {
    id: EMAIL_ROUTE,
    path: '/submitEmail',
    exact: false,
    component: SubmitEmail,
    label: 'Optimizer',
  },
  {
    id: ROOT_ROUTE,
    path: '/',
    exact: true,
    component: IndexPage,
    label: 'Optimizer',
  },
]

export default routes
